import store from "../../../store";
import { IConfiguration, ISystemWindowRestorerStoredKeyConfiguration } from "../../../domain/configuration";
import { IConfigurationRepository } from "../../../domain/developer";
import { ConfiguredRequestConfig, HttpRepository } from "../..";
import { ConfigurationRepository as Base } from "../../configuration/ver2";
import { IRectangle } from "../../../domain/system";
import Enumerable from "linq";

export class ConfigurationRepository<TConfiguration extends IConfiguration = IConfiguration> extends HttpRepository implements IConfigurationRepository {
  constructor(private _getToken: () => string) {
    super();
    this._repository = new Base();
  }

  private readonly _repository: Base;

  get storedKeys(): ISystemWindowRestorerStoredKeyConfiguration[] {
    return store.getters.configuration.system.window.restorer.storedKeys;
  }

  public getDefaultConfiguration(): IConfiguration {
    return this._repository.getDefaultConfiguration();
  }

  public async getSystemConfiguration(): Promise<IConfiguration> {
    return this._repository.getSystemConfiguration();
  }

  public async getTerminalConfiguration(hostName: string): Promise<IConfiguration> {
    return this._repository.getTerminalConfiguration(hostName);
  }

  public async registerSystemConfiguration(configuration: IConfiguration): Promise<void> {
    if (!configuration) { throw new Error("configuration is empty!!!"); }
    const data = {
      token: this._getToken(),
      value: JSON.stringify(configuration),
    };
    await this.post("/api/settings/system/save", data);
  }

  public async registerTerminalConfiguration(hostName: string, configuration: IConfiguration): Promise<void> {
    if (!hostName || hostName === "") { throw new Error("hostName is empty!!!"); }
    if (!configuration) { throw new Error("configuration is empty!!!"); }
    const data = {
      token: this._getToken(),
      value: JSON.stringify(configuration),
      hostName,
    };
    await this.post("/api/settings/terminal/save", data);
  }

  public async deleteTerminalConfiguration(hostName: string): Promise<void> {
    if (!hostName || hostName === "") { throw new Error("端末名が空です"); }
    const data = {
      token: this._getToken(),
      hostName,
    };
    const result = await this.post("/api/settings/terminal/delete", data);
    if (result.data === 1) {
      throw new Error("端末設定がありませんでした。");
    }
    if (result.data === 2) {
      throw new Error("端末設定削除に失敗しました");
    }
  }

  private getStoredKey(windowName: string): string {
    const storedKey = Enumerable.from(this.storedKeys ? this.storedKeys : []).where(k => k.route === windowName).select(k => k.key).firstOrDefault();
    return storedKey ? storedKey : "";
  }

  public async registerWindowRectangle(hostName: string, windowName: string, rectangle: IRectangle): Promise<void> {
    if (!hostName || hostName === "") { throw new Error("hostName is empty!!!"); }
    if (!rectangle) { throw new Error("rectangle is empty!!!"); }
    const storedKey = this.getStoredKey(windowName);
    const data = {
      windowName: storedKey ? storedKey : windowName,
      value: JSON.stringify(rectangle),
      hostName: hostName,
    };
    await this.post("/api/settings/terminal/windowRectangle/save", data);
  }

  public async getWindowRectangle(hostName: string, windowName: string): Promise<IRectangle> {
    if (!hostName) { return null; }
    const storedKey = this.getStoredKey(windowName);
    const requestConfig = {
      params: {
        windowName: windowName,
        hostName: hostName,
        storedKey: storedKey,
      },
    };
    const result = await this.get(
      "/api/settings/terminal/windowRectangle/get",
      ConfiguredRequestConfig.create(requestConfig));
    return JSON.parse(result.data.value);
  }
  
  public async getAssemblyVer(): Promise<string> {
    const ret = await this._repository.getAssemblyVer();
    return ret;
  }


}
